// Client-side intervention masking (P2-33).
//
// Two independent guards, both enforced on the AI free-selection candidate set via the
// `setDisabledInterventionTypes` runtime seam (see ReaderManager.handleStoryChange):
//   1. Above a district-configured ARM threshold, segmenting phoneme interventions are hidden.
//   2. In the Spanish (es-mx) tutor, English-only interventions are always blocked.
//
// Lists are plain intervention-type strings (matching how the heuristic policy compares
// `intervention.getType()` and how configs_es-mx.js lists disabled types). The ARM mask
// applies to every student in a district that configures it — there is no early-reader
// exemption.

// Segmenting phoneme interventions hidden above the district ARM threshold.
export const PHONEME_SEGMENTING_INTERVENTIONS = [
  'elkoninBox1', 'elkoninBox2', 'elkoninBox3', 'elkoninBox4', 'phonemeLipsync',
  'wordScramble1', 'changeOnePart1', 'phonemeGiveWord', 'giveAndTake1', 'sayASound',
  'soundout1', 'soundout2', 'soundout3', 'upAndDown1', 'upAndDown2', 'upAndDown3',
];

// English-only interventions always blocked in the Spanish (es-mx) tutor.
export const SPANISH_BLOCKED_INTERVENTIONS = [
  'cognate', 'elkoninBox0', 'GSF', 'hfwDotGrid', 'prediction', 'rhyming1', 'rhymingQuiz1',
  'sayit', 'silentSound', 'spellout', 'spelloutBefore', 'tense',
];

export const DEFAULT_ARM_THRESHOLD = 1.5;

// Returns the intervention types to disable for the current student/story.
//   locale:       session locale (e.g. 'es-mx')
//   ARM:          student ARM score (~0-8)
//   armThreshold: district-configured ARM threshold
export function getMaskedInterventionTypes({ locale, ARM, armThreshold }) {
  const masked = [];

  if (locale === 'es-mx') {
    masked.push(...SPANISH_BLOCKED_INTERVENTIONS);
  }

  // Strictly above: a student at exactly the threshold still sees these interventions.
  if (typeof ARM === 'number' && ARM > armThreshold) {
    masked.push(...PHONEME_SEGMENTING_INTERVENTIONS);
  }

  return [...new Set(masked)];
}
